import type { FC } from 'react'
import type { LinePaymets } from '../../interfaces'

import classNames from 'classnames'

interface IButtonGrid {
  record: LinePaymets
  choseSure: (fileNames: string, groupNumber: string, type: string, entId: string) => void
  isSure: boolean
  eventRebuild: (fileNames: string, groupNumber: string) => void
  isPending?: boolean
}
const Rebuild: FC<IButtonGrid> = ({ choseSure, isSure, eventRebuild, isPending, record }) => {
  const typeButton = 'Rebuild'
  const classList = classNames('rebuild', { 'rebuild-right': isSure })
  return (
    <button
      disabled={isPending}
      onClick={
        isSure
          ? () => {
              eventRebuild(record.filenamesList, record.groupNumber)
            }
          : () => {
              choseSure(record.filenamesList, record.groupNumber, typeButton, record.entId)
            }
      }
      className={classList}
    >
      {isSure ? 'Right?' : 'Rebuild'}
    </button>
  )
}

export default Rebuild
